import React, { useState } from "react";
import { Copy, Check } from "lucide-react";
import { toast } from "sonner";

// Single source of truth — update here when the real CA drops.
export const CONTRACT_ADDRESS = "CWvAZdgRxPkKufEz2qt6DT65b1H9LDqjwuDu75Fspump";

const isPlaceholder = (v) => !v || v === "TBA" || v.length < 10;

/**
 * Copy-enabled contract address pill.
 * Props:
 *   - size: "sm" | "md" (controls padding/font)
 *   - fullAddress: show the whole address (true) or first/last chars (false, default on sm)
 *   - dataTestid: override the test id
 */
export const ContractBadge = ({
  size = "sm",
  fullAddress = false,
  dataTestid = "contract-address",
}) => {
  const [copied, setCopied] = useState(false);
  const placeholder = isPlaceholder(CONTRACT_ADDRESS);

  const handleCopy = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    try {
      await navigator.clipboard.writeText(CONTRACT_ADDRESS);
      setCopied(true);
      if (placeholder) {
        toast.message("Still TBA — drops at launch", {
          description: "We'll light this up the moment Paul mints.",
        });
      } else {
        toast.success("Contract copied");
      }
      setTimeout(() => setCopied(false), 1500);
    } catch {
      toast.error("Copy failed");
    }
  };

  // Truncated display for long addresses on the small pill
  const display =
    placeholder || fullAddress
      ? CONTRACT_ADDRESS
      : `${CONTRACT_ADDRESS.slice(0, 4)}…${CONTRACT_ADDRESS.slice(-4)}`;

  const sizeCls =
    size === "md"
      ? "text-base px-3 py-1"
      : "text-[11px] px-2.5 py-1";

  return (
    <button
      onClick={handleCopy}
      title={placeholder ? "TBA — click anyway to grab the placeholder" : `Copy ${CONTRACT_ADDRESS}`}
      className={`inline-flex items-center gap-1.5 font-mono uppercase tracking-[0.2em] border transition-colors cursor-pointer ${sizeCls}`}
      style={{
        borderColor: "var(--p-red)",
        color: "var(--p-red)",
        background: "rgba(255,74,58,0.08)",
        letterSpacing: size === "md" ? "0.2em" : "0.25em",
      }}
      data-testid={dataTestid}
    >
      <span>{display}</span>
      {copied ? <Check size={size === "md" ? 14 : 12} /> : <Copy size={size === "md" ? 14 : 12} />}
    </button>
  );
};

export default ContractBadge;
